import { List, Map } from 'immutable';
import { DEFAULT_SESSION_ID } from '../constants';
import { addressActions } from './actions';
import { Address } from './address';

export function addressReducer(state = new Map(), action) {
  const { type, payload } = action;
  switch (type) {
    case addressActions.FETCH_ADDRESS_SUCCESS:
    case addressActions.FETCH_ADDRESS_PENDING:
    case addressActions.FETCH_ADDRESS_FAILED:
      return state.set(
        payload.addressId,
        adressItemReducer(state.get(payload.addressId), action)
      );
    case addressActions.LOAD_ADDRESS:
      return state.set(payload.addressId, adressItemReducer(state.get(payload.addressId), action));
    default:
      return state;
  }
}

export const adressItemReducer = (state = new Address() , { payload, type }  ) => {
  switch (type) {
    case addressActions.FETCH_ADDRESS_SUCCESS:
     return state.withMutations(address => {
       address
        .merge({
          isNew:false,
          isPending:false,
          ...payload.data
       })
      });
    case addressActions.FETCH_ADDRESS_FAILED:
        return state.set('isPending', false);
    case addressActions.FETCH_ADDRESS_PENDING:
      return state.set('isPending', true);
    case addressActions.LOAD_EFECTORES_BY_PRACTICE:
    case addressActions.LOAD_ADDRESS:
      return state.set('id',  payload.addressId);
    default:
      return state;
  }
}
